import React, { useEffect, useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { useDispatch, useSelector } from 'react-redux';
import { getScheduleReport } from '../../../redux/MainAction';
import { Button } from 'reactstrap';
import AddEditScheduleModal from './AddEditScheduleModal';
import Toggle from 'react-toggle';
import { Link } from 'react-router-dom';

const ScheduleReportList = () => {
  const dispatch = useDispatch();
  const scedule = useSelector((state) => state?.Webtracker?.scheduleReport);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editID, setEditID] = useState(false);

  useEffect(() => {
    getList();
  }, []);

  const getList = () => {
    var data = {
      offset: 0,
      limit: 10,
    };
    dispatch(getScheduleReport(data));
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  console.log('scedule', scedule);

  const handleEdit = (id) => {
    setEditID(id);
    toggleModal();
  };

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="col-12 d-flex align-items-center mb-2 ">
          <h5 className="text-muted col-2"></h5>
          <div
            className="col-10 d-flex justify-content-end align-items-center"
            style={{ gap: '20px' }}
          >
            <Link to="/tracked-hours">
              <Button className="" size="sm" color="indigo">
                <i className="mdi mdi-keyboard-backspace"></i> Back
              </Button>
            </Link>
            <Button
              className=""
              size="sm"
              color="dark"
              onClick={() => handleEdit(false)}
            >
              + Add Schedule Report
            </Button>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <AddEditScheduleModal
              open={isModalOpen}
              onClose={toggleModal}
              editID={editID}
            />
            <div className="col-12">
              <div className="card m-b-20">
                <div className="card-body">
                  <div>
                    <table
                      id="datatable"
                      className="table dt-responsive nowrap table-vertical"
                      width="100%"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>Title</th>
                          <th>File Type</th>
                          <th>Report Period</th>
                          <th>time</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {scedule?.rows?.length > 0 ? (
                          scedule?.rows?.map((scd, idx) => (
                            <tr key={idx}>
                              <td>{scd?.title}</td>
                              <td>{scd?.fileType}</td>
                              <td>{scd?.reportPeriod}</td>
                              <td>{scd?.time}</td>
                              <td>
                                {
                                  <Toggle
                                    checked={
                                      scd?.status === 'ACTIVE' ? true : false
                                    }
                                  />
                                }
                              </td>
                              <td>
                                <i
                                  className="fa fa-pencil text-primary"
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => handleEdit(scd?.id)}
                                ></i>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center">
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default ScheduleReportList;
